export enum AppStatus {
  Initialized = 0,
  LoginStarted = 1, 
  LoginCompleted = 2,
  LogoutStarted = 3,
  LogoutCompleted = 4, 
  UserContextLoading = 5,
  Ready = 10  
}